import api from './api'

const walletDataProvider = {
    getUserCryptoTransactionDetail(params) {
        return api.post('Wallet/api/AdminCoin/UserCryptoCurrencyTransactionDetail', params)
    },
    getCryptoDetails(params) {
        return api.post('Wallet/api/AdminCoin/CryptoCurrencyDetail', params)
    },
    getCryptoNetworkDetails(params) {
        return api.post('Wallet/api/AdminCoin/CryptoCurrencyNetworkDetail', params)
    },
    rollBackTransaction(params) {
        return api.post('Wallet/api/AdminCoin/RollBackTransaction', params)
    },
    editCryptoCurrencyDetail(params) {
        return api.post('Wallet/api/AdminCoin/EditCryptoCurrencyDetail', params)
    },
    editCryptoCurrencyNetworkDetail(params) {
        return api.post('Wallet/api/AdminCoin/EditCryptoCurrencyNetworkDetail', params)
    },
    getSpecificUserWalletTransactionsFromUsermanagement(params){
        return api.post('Wallet/api/AdminCoin/UserCoinCryptoCurrencyTransaction', params)
    },
    getSpecificUserWalletTransactionsFromListsWallet(params){
        return api.post('Wallet/api/AdminCoin/UserWalletCoinCryptoCurrencyTransaction', params)
    },
    getTomanTransactionDetail(params){
        return api.post('Wallet/api/AdminCoin/TomanTransactionDetail', params)
    },
    getCoinList(){
        return api.get('Wallet/api/Coin/AllSymbol')
    }

}

export default walletDataProvider
